import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-500);
`

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const Image = styled.img`
  height: 70px;

  ${mediaQueries.tablet} {
    width: 200px;
    height: 140px;
    object-fit: contain;
  }
`

export const Content = styled.div`
  & > * + * {
    margin-top: var(--space-300);
  }
`
export const Title = styled.div`
  font-size: var(--font-size-600);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-500);
  letter-spacing: var(--font-letter-spacing-densest);
`
